export default async function fetchData () {
  const $selector = document.querySelector('[data-review-slug]');

  if ($selector) {
    const $insertData = $selector.querySelector('[data-insert-data]')

    await fetch(`/wp-json/rest/v1/get-data/${$selector.dataset.reviewSlug}`)
      .then((res) => res.json())
      .then((data) => {
        $insertData.querySelector('.Loader').remove();
        $insertData.innerHTML = `
          <div class="single-rating-table__cell service">
              <img class="single-rating-table__cell__img"
                   src="${data.logo.url}" alt="" width="${data.logo.width}"/>
            </div>
            <div class="single-rating-table__cell">
              <div class="rating-feature">${data.description}</div>
            </div>
            <div
              class="single-rating-table__cell visit-site
               ${data.link === '//copycrafter.net/' ? 'single-rating-table__cell--with-gift-btn' : '' }
             ">
        
              <a rel="nofollow" target="_blank" href="${data.sample}" class="btn btn--white rating--sample">
              Sample
                <img src="/wp-content/themes/omnipapers-new/img/img_sample.svg" alt="" height="16" width="16"/>
              </a>
        
              <a rel="nofollow" target="_blank" href="${data.link}" class="btn btn--orange rating--visit">Visit
                <img src="/wp-content/themes/omnipapers-new/img/visit_img.svg" alt="" height="16" width="16"/>
              </a>
              ${data.link === '//copycrafter.net/' ? `<a rel="nofollow" target="_blank"
                   href="https://copycrafter.net/order.html?couponCode=STEM20OFF&orderServiceTypeId=46"
                   class="btn btn--green btn--gift rating--order">
                  -20% on STEM task
                  <img src="/wp-content/themes/omnipapers-new/img/img_gift.svg" alt="-20% on STEM task">
                </a>` : data.link === '//easyessay.us/' ? ` <a rel="nofollow" target="_blank" href="https://easyessay.us/order.html?couponCode=WELCOME10OFF&paperTypeId=2"
                   class="btn btn--green btn--gift rating--order">
                  -10% on 1st order
                  <img src="/wp-content/themes/omnipapers-new/img/img_gift.svg" alt="-10% on 1st order" height="16" width="16">
                </a>` : data.link === '//do-my-essay.org/' ? ` <a rel="nofollow" target="_blank" href="https://do-my-essay.org/order.html?couponCode=1FREEPAGE&pages=3"
                   class="btn btn--green btn--gift rating--order">
                  Get 1 Free Page
                  <img src="/wp-content/themes/omnipapers-new/img/img_gift.svg" height="16" width="16" alt="Get 1 Free Page">
                </a>` :  data.orderPageLink ? `<a rel="nofollow" target="_blank" href="${data.orderPageLink}"
                   class="btn btn--white-orange rating--order">Order</a>` : ''}
            </div>
        `;
        $selector.classList.remove('single-rating-table--hidden');
      })
  }
}
